import React, { useState, useEffect } from 'react';
import Navbar from '../../components/Navbar';
import API from '../../utils/api';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';

export default function TeacherBranding() {
  const { user, refreshUser } = useAuth();
  const [form, setForm] = useState({ teacher_phone: '' });
  const [logo, setLogo] = useState(null);
  const [preview, setPreview] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setForm({ teacher_phone: user?.teacher_phone || user?.phone || '' });
    setPreview(user?.teacher_logo || null);
  }, [user]);

  const handleLogo = e => {
    const file = e.target.files[0];
    setLogo(file);
    if (file) setPreview(URL.createObjectURL(file));
  };

  const save = async e => {
    e.preventDefault();
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append('teacher_phone', form.teacher_phone);
      fd.append('full_name', user?.full_name || '');
      if (logo) fd.append('teacher_logo', logo);
      await API.post('/auth/branding', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      await refreshUser();
      toast.success('✅ Branding saved! Will appear on all PDFs.');
    } catch (err) { toast.error(err.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <Navbar />
      <div style={{ maxWidth:700, margin:'0 auto', padding:'32px 20px' }}>
        <div className="page-header">
          <h1>🎨 PDF Branding</h1>
          <p>Your info will appear on all student answer sheet PDFs</p>
        </div>

        <div className="alert alert-info" style={{ marginBottom:24 }}>
          <strong>📄 PDF Layout Preview:</strong>
          <div style={{ marginTop:12, background:'white', color:'#333', borderRadius:8, padding:16, fontSize:12, fontFamily:'serif' }}>
            <div style={{ display:'flex', alignItems:'center', gap:12, borderBottom:'2px solid #333', paddingBottom:10, marginBottom:10 }}>
              <div style={{ width:50, height:50, background:'#e5e7eb', borderRadius:4, display:'flex', alignItems:'center', justifyContent:'center', fontSize:10, color:'#666' }}>YOUR LOGO</div>
              <div>
                <div style={{ fontWeight:700, fontSize:14 }}>{user?.full_name}</div>
                <div style={{ fontSize:11, color:'#666' }}>📞 {form.teacher_phone}</div>
              </div>
            </div>
            <div style={{ fontSize:11, color:'#666', marginBottom:8 }}>Student: _______ | Phone: _______ | Roll No: _______</div>
            <div style={{ fontSize:11, marginBottom:4 }}>Q1. Question text here...</div>
            <div style={{ fontSize:11, color:'#888', marginBottom:4 }}>Ans: _______________</div>
            <div style={{ opacity:0.15, position:'relative', textAlign:'center', fontSize:14, fontWeight:700, color:'#6366f1', transform:'rotate(-30deg)', margin:'8px 0' }}>{user?.full_name} WATERMARK</div>
            <div style={{ borderTop:'1px solid #ccc', paddingTop:8, textAlign:'center', fontSize:10, color:'#999' }}>Powered by Oexams • Smart Exams for Smart Teachers</div>
          </div>
        </div>

        <form onSubmit={save}>
          <div className="card">
            <h3 style={{ fontWeight:700, marginBottom:20 }}>Your Branding Info</h3>
            <div className="form-group">
              <label>Your Name (used on PDF)</label>
              <input value={user?.full_name || ''} disabled style={{ opacity:0.7 }} />
              <p style={{ fontSize:11, color:'var(--text3)', marginTop:4 }}>Change from Profile page</p>
            </div>
            <div className="form-group">
              <label>Your Phone (shown on PDF header)</label>
              <input type="tel" value={form.teacher_phone} onChange={e => setForm(f=>({...f,teacher_phone:e.target.value}))} placeholder="Phone number for PDF header" />
            </div>
            <div className="form-group">
              <label>Your Logo / Institute Logo</label>
              {preview && (
                <div style={{ marginBottom:12 }}>
                  <img src={preview} alt="logo preview" style={{ height:70, borderRadius:8, border:'1px solid var(--border)', objectFit:'contain', background:'white', padding:4 }} />
                  <p style={{ fontSize:11, color:'var(--text3)', marginTop:4 }}>Current logo</p>
                </div>
              )}
              <input type="file" accept="image/*" onChange={handleLogo} style={{ padding:8 }} />
              <p style={{ fontSize:11, color:'var(--text3)', marginTop:4 }}>Shown in top-left of every PDF. Recommended: 200×80px</p>
            </div>
            <div className="alert alert-warning" style={{ marginBottom:16, fontSize:13 }}>
              💡 Your name will also appear as a <strong>diagonal watermark</strong> across all pages of the student's answer sheet PDF.
            </div>
            <button type="submit" className="btn btn-primary btn-lg" disabled={saving}>{saving ? '⏳ Saving...' : '💾 Save Branding'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
